window.addEventListener("videowiseProductAddToCart", async (e) => {
  if (window.innerWidth < 768) {
    document
      .querySelector(".ReactModal__Content.ReactModal__Content--after-open")
      .shadowRoot.querySelector(".vw-cmp__shoppable--close-button.vw__icon-svg")
      .click();
    theme.ajaxCart.load();
    theme.modal.open(cartModal);
  }

  setTimeout(() => {
    document
      .querySelector(".ReactModal__Content.ReactModal__Content--after-open")
      .shadowRoot.querySelector(
        ".vw-cmp__player--button-close.vw-cmp__player--button"
      )
      .click();
    theme.ajaxCart.load();
    theme.modal.open(cartModal);
  }, 250);
});
